import { render } from "./ServerError.vue?vue&type=template&id=1b9680f8"
const script = {}

import "./ServerError.vue?vue&type=style&index=0&id=1b9680f8&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__